module.exports = __webpack_public_path__ + "img/idenfo-direct-verification-seal.dc087456.png";